export default function memoize<R, T extends (...args: any[]) => R> (f: T): T {
  const cache = new Map<string, R>()

  const g = (...args: any[]) => {
    const firstArg = args[0]

    if (!cache.get(firstArg)) {
      cache.set(firstArg, f(...args))
    }

    return cache.get(firstArg)
  }

  return g as T
}



// WEBPACK FOOTER //
// ./src/utils/memoize.ts